var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 10.6875C10.141 10.6875 9.65586 11.25 8 11.25C6.34414 11.25 5.8625 10.6875 4.85 10.6875C2.24141 10.6875 0.125 12.8039 0.125 15.4125V16.3125C0.125 17.2441 0.880859 18 1.8125 18H14.1875C15.1191 18 15.875 17.2441 15.875 16.3125V15.4125C15.875 12.8039 13.7586 10.6875 11.15 10.6875ZM14.1875 16.3125H1.8125V15.4125C1.8125 13.7391 3.17656 12.375 4.85 12.375C5.36328 12.375 6.19649 12.9375 8 12.9375C9.81758 12.9375 10.6332 12.375 11.15 12.375C12.8234 12.375 14.1875 13.7391 14.1875 15.4125V16.3125ZM8 10.125C10.7949 10.125 13.0625 7.85742 13.0625 5.0625C13.0625 2.26758 10.7949 0 8 0C5.20508 0 2.9375 2.26758 2.9375 5.0625C2.9375 7.85742 5.20508 10.125 8 10.125ZM8 1.6875C9.85977 1.6875 11.375 3.20273 11.375 5.0625C11.375 6.92227 9.85977 8.4375 8 8.4375C6.14023 8.4375 4.625 6.92227 4.625 5.0625C4.625 3.20273 6.14023 1.6875 8 1.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMobile);
export default __webpack_public_path__ + "static/media/User_mobile.ae77958196d1c63c1c9ebb4c157b510c.svg";
export { ForwardRef as ReactComponent };